export default "__VITE_ASSET__B1Xz9zt$__"